var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "summary-item-background noselect"
  }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _c('a', {
    staticClass: "bl-color pointer",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.cloudFile.file,
      "download": _vm.cloudFile.name
    }
  }, [_vm._v(" STIAHNUŤ ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }